<template>
  <el-card>
    <ExportButton v-show="items.length > 1" @click="download" />
    <el-table
      :data="items"
      border
      size="small"
      style="width: 100%; margin-top: 20px; font-size: 9px"
    >
      <el-table-column
        prop="title"
        label="Campaign"
        header-align="center"
        width="250"
      />
      <el-table-column
        prop="impressions"
        label="Impressions"
        header-align="center"
        sortable
      />
      <el-table-column
        prop="cpm"
        label="My eCPM"
        header-align="center"
        sortable
      />
      <el-table-column
        prop="limits"
        label="My limits"
        header-align="center"
        sortable
      />
      <el-table-column prop="completion" label="Completion" sortable>
        <template #default="{ row }">
          <PercentLabel v-model="row.completion" />
        </template>
      </el-table-column>
      <el-table-column
        prop="volumes"
        label="Market volume"
        header-align="center"
        sortable
      />
      <el-table-column
        prop="win_percent"
        label="Won %"
        header-align="center"
        sortable
      >
        <template #default="{ row }">
          <PercentLabel v-model="row.win_percent" />
        </template>
      </el-table-column>
      <el-table-column
        prop="avg_cpm"
        label="Marketplace eCPM"
        header-align="center"
        sortable
      />
      <el-table-column
        prop="lost_impressions"
        label="Impressions lost"
        header-align="center"
        sortable
      />
    </el-table>
  </el-card>
</template>

<script lang="ts">
import useResize from '@/hooks/useResize'

import { defineComponent, computed, ref, watch } from 'vue'
import PercentLabel from './PercentLabel.vue'
import ExportButton from '@/components/ExportButton.vue'

export default defineComponent({
  name: 'DailyTable',
  components: {
    PercentLabel,
    ExportButton
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const { isDesktop } = useResize()

    const download = (format: string) => {
      context.emit('download', format)
    }

    return { isDesktop, download }
  }
})
</script>

<style lang="scss" scoped>
.el-card {
  padding: 0;
  margin-top: 10px;
  position: relative;
}

.el-link {
  right: 20px;
  position: absolute;
  top: 10px;
  z-index: 2;
}

:deep(.el-table) {
  .caret-wrapper {
    width: 15px;
  }

  th > .cell {
    padding: 0 0 0 2px;
    font-size: 8px;
  }
}
</style>
